module.exports = __webpack_public_path__ + "static/img/3.63d9650.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/eng/3.png
// module id = kXkF
// module chunks = 0